import {App} from './app';

export const AppContainer = App;
